/* PSM Product Reviews — write-form flow. Drives snippets/psm-reviews-product.liquid.
   Mirrors psm-tax-exempt.js: event-delegated (survives AJAX), guarded against
   double-init, login enforced at submit (and server-side by the App Proxy).

   "Write a review" click:
     - guest     -> show the login prompt
     - logged-in -> open the write form
   Submit:
     - validate rating + body in JS, show progress
     - POST multipart to the App Proxy path (data-proxy-path)
     - approved -> "published"; queued -> "we're checking it"; failure -> retry
   Demo mode (data-demo="true") simulates the backend so the UI is reviewable
   on a preview theme before the backend exists.
*/
(function () {
  if (window.__psmReviewsInit) return;
  window.__psmReviewsInit = true;

  var MODAL_STATES = ['is-open', 'is-loading', 'is-done', 'is-queued', 'is-error'];

  function setState(box, state) {
    ['is-open', 'is-loading', 'is-done', 'is-queued', 'is-error', 'is-login-needed'].forEach(function (c) {
      box.classList.remove(c);
    });
    if (state) box.classList.add(state);
    // Lock background scroll while the lightbox (any modal state) is visible.
    document.body.classList.toggle('psm-rv-lock', MODAL_STATES.indexOf(state) >= 0);
  }

  // Esc closes the lightbox.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.psm-rv.is-open, .psm-rv.is-done, .psm-rv.is-queued, .psm-rv.is-error');
    if (open) setState(open, '');
  });

  // Set the star picker to N (preselect).
  function setRating(box, n) {
    var group = box.querySelector('[data-psm-rv-rating]');
    if (!group) return;
    group.setAttribute('data-rv-value', String(n));
    [].forEach.call(group.querySelectorAll('[data-rv-star]'), function (b) {
      b.classList.toggle('is-on', parseInt(b.getAttribute('data-rv-star'), 10) <= n);
    });
  }

  // Frictionless email flow: a star in the review-request email links to
  // /products/<handle>?rating=N[&rv=<token>]#reviews. On arrival, open the
  // lightbox with that rating already selected (and carry the token so the
  // submit works without a login). The customer just taps Submit (or adds text).
  function initFromUrl() {
    var box = document.querySelector('[data-psm-rv]');
    if (!box || box.__psmRvUrlDone) return;
    var qs = location.search || '';
    var rm = qs.match(/[?&]rating=([1-5])\b/);
    if (!rm) return;
    box.__psmRvUrlDone = true;
    var token = (qs.match(/[?&]rv=([^&#]+)/) || [])[1];
    if (token) box.dataset.rvToken = decodeURIComponent(token);
    // Show what they're reviewing (model + qty from the email link; token is authoritative for submit).
    var model = (qs.match(/[?&]model=([^&#]+)/) || [])[1];
    var qty = (qs.match(/[?&]qty=([^&#]+)/) || [])[1];
    var ctx = box.querySelector('[data-psm-rv-ctx]');
    if (ctx && (model || token)) {
      var parts = [];
      if (model) parts.push('Reviewing <b>' + decodeURIComponent(model).replace(/[<>&]/g, '') + '</b>');
      if (qty) parts.push('Qty ' + decodeURIComponent(qty).replace(/[^0-9]/g, ''));
      if (token) parts.push('<span class="vb">✓ Verified purchase</span>');
      ctx.innerHTML = parts.join(' · ');
      ctx.hidden = false;
    }
    setState(box, 'is-open');          // token implies identity; else login enforced at submit
    setRating(box, parseInt(rm[1], 10));
    try { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }
  if (document.readyState !== 'loading') initFromUrl();
  else document.addEventListener('DOMContentLoaded', initFromUrl);

  function currentCustomerId() {
    try {
      var sa = window.ShopifyAnalytics;
      if (sa && sa.meta && sa.meta.page && sa.meta.page.customerId) return String(sa.meta.page.customerId);
    } catch (e) {}
    try { if (window.__st && window.__st.cid) return String(window.__st.cid); } catch (e) {}
    return '';
  }

  function isLoggedIn(box) {
    if (box.dataset.loggedIn === 'true') return true;
    if (box.dataset.customerId) return true;
    return !!currentCustomerId();
  }

  // Open the write form for logged-in shoppers; show the login prompt for guests.
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-psm-rv-open]');
    if (open) {
      var box = open.closest('[data-psm-rv]');
      if (!box) return;
      if (isLoggedIn(box)) setState(box, 'is-open');
      else box.classList.add('is-login-needed');
      return;
    }

    var close = e.target.closest('[data-psm-rv-close]');
    if (close) {
      var cbox = close.closest('[data-psm-rv]');
      if (cbox) setState(cbox, '');
      return;
    }

    var retry = e.target.closest('[data-psm-rv-retry]');
    if (retry) {
      var rbox = retry.closest('[data-psm-rv]');
      if (rbox) setState(rbox, 'is-open');
      return;
    }

    var login = e.target.closest('[data-psm-rv-login]');
    if (login) {
      e.preventDefault();
      var lbox = login.closest('[data-psm-rv]');
      var u = (lbox && lbox.dataset.loginUrl) || '/account/login';
      u += (u.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(location.pathname + location.search + '#reviews');
      window.location.href = u;
      return;
    }

    // Star picker
    var star = e.target.closest('[data-rv-star]');
    if (star) {
      var group = star.closest('[data-psm-rv-rating]');
      var val = parseInt(star.getAttribute('data-rv-star'), 10);
      group.setAttribute('data-rv-value', String(val));
      [].forEach.call(group.querySelectorAll('[data-rv-star]'), function (b) {
        b.classList.toggle('is-on', parseInt(b.getAttribute('data-rv-star'), 10) <= val);
      });
      return;
    }
  });

  document.addEventListener('click', function (e) {
    var submit = e.target.closest('[data-psm-rv-submit]');
    if (!submit) return;

    var box = submit.closest('[data-psm-rv]');
    var panel = box && box.querySelector('[data-psm-rv-form]');
    if (!panel) return;

    var ratingGroup = panel.querySelector('[data-psm-rv-rating]');
    var rating = ratingGroup ? parseInt(ratingGroup.getAttribute('data-rv-value') || '0', 10) : 0;
    var bodyInput = panel.querySelector('[data-field="body"]');
    var body = bodyInput ? bodyInput.value.trim() : '';

    if (!rating) { ratingGroup && ratingGroup.classList.add('is-missing'); return; }
    ratingGroup && ratingGroup.classList.remove('is-missing');
    // Body is OPTIONAL — a star rating on its own is a valid review (frictionless).

    setState(box, 'is-loading');

    if (box.dataset.demo === 'true') {
      window.setTimeout(function () { setState(box, 'is-done'); }, 1800);
      return;
    }

    var fd = new FormData();
    fd.append('rating', String(rating));
    panel.querySelectorAll('[data-field]').forEach(function (el) { fd.append(el.dataset.field, el.value); });
    fd.append('product_id', box.dataset.productId || '');
    fd.append('product_handle', box.dataset.productHandle || '');
    fd.append('group', box.dataset.group || '');
    fd.append('customer_id', box.dataset.customerId || currentCustomerId() || '');
    fd.append('shop', box.dataset.shop || '');
    if (box.dataset.rvToken) fd.append('rv_token', box.dataset.rvToken);   // email one-tap identity (no login needed)
    if (box.dataset.testToken) fd.append('test_token', box.dataset.testToken);

    fetch(box.dataset.proxyPath, { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json().catch(function () { return {}; }) : Promise.reject(r.status); })
      .then(function (res) { setState(box, res && res.status === 'approved' ? 'is-done' : 'is-queued'); })
      .catch(function (err) {
        if (err === 403) { setState(box, ''); box.classList.add('is-login-needed'); }
        else { setState(box, 'is-error'); }
      });
  });
})();
